module.exports = __webpack_public_path__ + "img/Kaspersky-Endpoint-Security.13b18e6.svg";